import { SET_LEADS, SET_LEADS_LIST,  SET_TEMPLATES, SET_NUMBERS, SET_CURRENT_NUMBER, SET_PAYMENT_INFO, CLEAR_LEADS } from './kaiziqLeadsTypes';

const initialState = {
    currentLeads: null,
    currentPhoneNumber: null,
    paymentInfo: null,
    templateList: [],
    numbersList: [],
    leadsList: [],
    loading: false
};

export default function leadsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LEADS:
            return { ...state, currentLeads: action.payload };
        case SET_LEADS_LIST:
            return { ...state, leadsList: action.payload };
        case SET_TEMPLATES:
            return { ...state, templateList: action.payload };
        case SET_NUMBERS:
            return { ...state, numbersList: action.payload };
        case SET_CURRENT_NUMBER:
            return { ...state, currentPhoneNumber: action.payload };
        case SET_PAYMENT_INFO:
            return { ...state, paymentInfo: action.payload };
        case CLEAR_LEADS:
            return initialState;
        default:
            return state;
    }
}